import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { ProgressBar } from 'primeng/progressbar';
import type { SnapshotUiProgressRow } from '../mock/financial-snapshot-compute';

@Component({
  selector: 'bn-financial-snapshot-progress',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ProgressBar, CurrencyPipe],
  template: `
    <div class="bn-fs-progress">
      <div class="bn-fs-progress__toolbar">
        <div class="bn-fs-progress__bar-wrap">
          <p-progressbar
            [value]="percent()"
            [showValue]="false"
            styleClass="bn-fs-progress__bar"
            [attr.aria-label]="'Snapshot progress ' + enteredCount() + ' of ' + totalCount()"
          />
        </div>
        <div class="bn-fs-progress__actions">
          <ng-content select="[fsActions]" />
        </div>
      </div>
      <ul class="bn-fs-progress__list">
        @for (row of rows(); track row.id) {
          <li class="bn-fs-progress__item" [class.bn-fs-progress__item--done]="row.entered">
            <i
              class="pi"
              [class.pi-check-circle]="row.entered"
              [class.pi-circle]="!row.entered"
              aria-hidden="true"
            ></i>
            <span class="bn-fs-progress__label">{{ row.label }}</span>
            <span class="bn-fs-progress__value">
              @if (row.entered && row.amount !== null) {
                <span class="bn-fs-progress__amount">{{
                  row.amount | currency: 'USD' : 'symbol' : '1.0-0'
                }}</span>
                @if (row.source === 'client') {
                  <span class="bn-fs-progress__source">Client</span>
                }
              } @else {
                <span class="bn-fs-progress__pending">Pending</span>
              }
            </span>
          </li>
        }
      </ul>
    </div>
  `,
  styleUrl: './snapshot-progress.component.scss',
})
export class FinancialSnapshotProgressComponent {
  readonly rows = input.required<SnapshotUiProgressRow[]>();
  readonly enteredCount = input.required<number>();
  readonly totalCount = input.required<number>();
  readonly percent = input.required<number>();
}
